export default __webpack_public_path__ + "static/hero-image-5-0988d22d3575851032546d78d78e596f.jpeg";